import Cookies from "js-cookie";

import { MessageBus } from "./message_bus.js";
import { EventBus } from "./event_bus.js";
import { APP } from "./app.js";

export class FinalThoughts {
  #form
  #cancelButton
  #submitButton
  #rememberInfoCheck
  #contactBlocks
  #contactFields
  #contactLead
  #recognised = false
  #termsAccepted = false
  #finished = false

  constructor() {
    this.#form = document.querySelector("#final-thoughts-form");
    this.#cancelButton = document.querySelector("#final-thoughts-cancel-button");
    this.#submitButton = document.querySelector("#final-thoughts-submit-button");
    this.#rememberInfoCheck = document.querySelector("#final-thoughts-remember-info-check");
    this.#contactBlocks = this.#form.querySelectorAll(".final-thoughts-contact");
    this.#contactFields = [...this.#form.querySelectorAll("#final-thoughts-name, #final-thoughts-email"), this.#rememberInfoCheck];
    this.#contactLead = document.querySelector("#final-thoughts-contact-lead");

    this.#setEvents();
    this.#checkIfInfoIsRemembered();
    this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
  }

  // API :: INI
  // Waits for the check: a recognised playtester's remembered name and email go nowhere
  async sendInfoIfAlreadyRemembered() {
    this.#termsAccepted = true;
    await APP.playtesterIdentity.whenChecked();

    if (!this.#recognised) {
      this.#sendRememberedInfo();
    }
  }
  // API :: END

  #sendRememberedInfo() {
    const name = this.#form.querySelector("#final-thoughts-name").value;
    const email = this.#form.querySelector("#final-thoughts-email").value;

    if ((name !== "") || (email !== "")) {
      // In the background: a failure here is not worth a modal
      APP.playcocolaAPI.sendFinalThoughts(name, email, "").catch((error) => {
        console.warn("sendRememberedInfo() failed", error);
      });
    }
  }

  async #setEvents() {
    this.#form.addEventListener("submit", (event) => {
      this.#onFormSubmit(event);
    });

    this.#rememberInfoCheck.addEventListener("change", (event) => {
      this.#rememberOrForgetInfo();
    });

    this.#cancelButton.addEventListener("click", (event) => {
      EventBus.event("final-thoughts-finished");
    });

    this.#form.querySelectorAll(".form-control").forEach((element) => {
      element.addEventListener("input", (event) => {
        this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
      });
    });

    EventBus.addListener("final-thoughts-finished", () => {
      this.#finished = true;
    });

    EventBus.addListener("playtester-identity-changed", () => {
      this.#identityChanged();
    });
  }

  // Hidden is not enough: a remembered invalid email, hidden, would silently stop the form from submitting
  #identityChanged() {
    const identity = APP.playtesterIdentity;
    const wasRecognised = this.#recognised;

    this.#recognised = identity.isRecognised;
    this.#contactBlocks.forEach((block) => block.classList.toggle("d-none", this.#recognised));
    this.#contactFields.forEach((field) => { field.disabled = this.#recognised; });
    this.#contactLead.classList.toggle("d-none", this.#recognised);
    this.#cancelButton.disabled = identity.isUnlinking;
    this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();

    // Gone guest after the terms: what a guest sends at the terms. After the Final thoughts it would blank their comment.
    if (wasRecognised && !this.#recognised && this.#termsAccepted && !this.#finished) {
      this.#sendRememberedInfo();
    }
  }

  #disableSubmitButton() {
    this.#submitButton.setAttribute("disabled", true);
  }

  #enableSubmitButton() {
    this.#submitButton.removeAttribute("disabled");
  }

  async #onFormSubmit(event) {;
    event.preventDefault();

    this.#disableSubmitButton();
    if (!this.#recognised) {
      this.#rememberOrForgetInfo();
    }
    try {
      await this.#sendFormInfo();
      EventBus.event("final-thoughts-finished");
    } catch (error) {
      MessageBus.error("Your final thoughts could not be sent. Please check your connection and try again.", error);
      this.#enableSubmitButton();
    }
  }

  async #sendFormInfo() {
    MessageBus.debug("FinalThoughtsFormSend :: ini")

    const name = this.#recognised ? "" : this.#form.querySelector("#final-thoughts-name").value;
    const email = this.#recognised ? "" : this.#form.querySelector("#final-thoughts-email").value;
    const comment = this.#form.querySelector("#final-thoughts-comment").value;

    await APP.playcocolaAPI.sendFinalThoughts(name, email, comment);
    MessageBus.debug("FinalThoughtsFormSend :: end");
  }

  #checkIfInfoIsRemembered() {
    if (Cookies.get("name") != undefined && Cookies.get("name") != "") {
      this.#form.querySelector("#final-thoughts-name").value = Cookies.get("name");
    }

    if (Cookies.get("email") != undefined && Cookies.get("email") != "") {
      this.#form.querySelector("#final-thoughts-email").value = Cookies.get("email");
    }

    if (Cookies.get("remember") != undefined) {
      this.#rememberInfoCheck.checked = true;
    }
  }

  #rememberOrForgetInfo() {
    const checked = this.#rememberInfoCheck.checked;
    if (checked) {
      Cookies.set("name", this.#form.querySelector("#final-thoughts-name").value, { expires: 90 });
      Cookies.set("email", this.#form.querySelector("#final-thoughts-email").value, { expires: 90 });
      Cookies.set("remember", true, { expires: 90 });
    } else {
      Cookies.remove("name");
      Cookies.remove("email");
      Cookies.remove("remember");
    }
  }

  #checkIfSubmitButtonShouldBeEnabledOrDisabled() {
    let result =
      Array(...this.#form.querySelectorAll(".form-control")).some((element) => {
        return !element.disabled && element.value.trim() !== "";
      });

    if (result && !APP.playtesterIdentity?.isUnlinking) {
      this.#enableSubmitButton();
    } else {
      this.#disableSubmitButton();
    }
  }
}
